<script>
import { mapState } from "vuex";

export default {
    name: "baseBox",
    computed: {
        ...mapState(['styles']),
        customUI () {
            return {
                background: this.isUserSend ? this.styles.secondaryColor : this.styles.primaryColor,
                color: this.isUserSend ? this.styles.secondaryTextColor : this.styles.primaryTextColor
            }
        },
        buttonCustomUI () {
            return {
                background: this.styles.buttonColor,
                color: this.styles.buttonTextColor,
                textAlign:  this.styles.buttonAlign,
                fontWeight: this.styles.buttonWeight
            }
        },
        buttonCustomUIHover () {
            return {
                background: this.styles.buttonColorHover ? this.styles.buttonColorHover: this.styles.buttonColor,
                color: this.styles.buttonTextColorHover ? this.styles.buttonTextColorHover: this.styles.buttonTextColor, 
                textAlign:  this.styles.buttonAlign,
                fontWeight: this.styles.buttonWeight,
                opacity: this.styles.buttonOpacityHover
            }
        },
        quickReplyButtonGroupCustomUI(){
            return {
                'text-align': this.styles.quickReplyButtonAlign,
            }
        },
        quickReplyButtonCustomUI(){
            return{
                'border-color': this.styles.quickReplyButtonBorderColor,
                background: this.styles.buttonColor,
                color: this.styles.buttonTextColor,
                textAlign:  this.styles.buttonAlign,
                fontWeight: this.styles.buttonWeight
            }
        },
        quickReplyButtonCustomUIHover(){
            return{
                'border-color': this.styles.quickReplyButtonBorderColorHover,
                background: this.styles.buttonColorHover ? this.styles.buttonColorHover: this.styles.buttonColor,
                color: this.styles.buttonTextColorHover ? this.styles.buttonTextColorHover: this.styles.buttonTextColor, 
                textAlign:  this.styles.buttonAlign,
                fontWeight: this.styles.buttonWeight,
            }
        }
    }
}
</script>
